import { AnalyticCountDTO } from '../dtos/AnalyticCount.dto';
import { AnalyticCountModel } from '../models/AnalyticCount.model';

export class AnalyticCountUtil {
  public static mapToViewModel(dto: AnalyticCountDTO): AnalyticCountModel {
    return {
      totalCount: dto.totalCount,
      weeklyCount: dto.inLastWeek,
    };
  }
}
